import { GoogleOAuthProvider } from '@react-oauth/google';
import { useFeatureFlags } from 'hooks/useFeatures';
import WithHeader from 'layout/WithHeader';
import GlobalModalContainer from 'modules/modals/components/GlobalModalContainer';
import { usePlayablePing } from 'modules/playable';
import usePushNotifications from 'hooks/usePushNotifications';
import React from 'react';
import { TermsOfServiceProvider } from 'modules/termsOfService/provider';
import { ScreenLoader } from 'ui';
import { ENV } from 'constants/env';
import ModalProvider from 'modules/modals/ModalProvider';
import Stream from 'modules/stream/Stream';
import { AuthenticatedRoutes } from 'routes/authenticated';
import { Toaster } from 'components/ui/toaster';
import { WalkthroughProvider } from 'modules/walkthrough/context';
import { YBugProvider } from 'modules/app/YBugContext';

export const AuthenticatedWrapper: React.FC = () => {
  const { features, isLoadingFeatureFlags } = useFeatureFlags();
  usePushNotifications();
  usePlayablePing();

  if (isLoadingFeatureFlags) {
    return <ScreenLoader />;
  }

  return (
    <TermsOfServiceProvider>
      <YBugProvider settings={{ id: ENV.VITE_YBUG_ID }}>
        <GoogleOAuthProvider clientId={ENV.VITE_GOOGLE_CLIENT_ID as string}>
          <WalkthroughProvider>
            <ModalProvider>
              <GlobalModalContainer />
              <Toaster />
              <WithHeader>
                <Stream>
                  <AuthenticatedRoutes />
                </Stream>
              </WithHeader>
            </ModalProvider>
          </WalkthroughProvider>
        </GoogleOAuthProvider>
      </YBugProvider>
    </TermsOfServiceProvider>
  );
};
